import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import * as PageNotifications from 'app/common/notifications/features/page-notifications';
import { CanAccess } from 'app/railways/domains/access/features/permissions';
import { appRoute } from 'app/terminals/router/routes';

import { PageContent } from '../../../../ui';
import { EmployeeDetails } from './employee-details';

export const DetailsEmployeePage = observer(() => {
  const { id } = useTypedParams(appRoute.EMPLOYEE);

  return (
    <PageContent>
      <CanAccess
        perm="PERM_EMPLOYEE_CREATE"
        fallback="У вас нет разрешений для просмотра этих данных"
      >
        <PageNotifications.Provider>
          <EmployeeDetails id={Number(id)} />
        </PageNotifications.Provider>
      </CanAccess>
    </PageContent>
  );
});
